import campMarketingSchema from './marketingSchema';
import translationSchema from '../translationSchema';

const campCreationSchema = campMarketingSchema.concat(translationSchema.required);

export default campCreationSchema;
